import {
  SET_CHECKOUT_STEP,
  SET_DELIVERY_METHOD,
  SET_SHIPPING_DATA,
  SET_SELECTED_STORE,
  SET_PICKUP_DATE,
  SET_SELECTED_SLOT,
  SET_PAYMENT_METHOD,
  RESET_CHECKOUT,
  FETCH_MARKETS_SUCCESS,
  FETCH_SLOTS_SUCCESS,
  SET_SHIPPING_COST,
  SHIPPING_COST_LOADING,
  SHIPPING_COST_ERROR,
  CHECK_CART_LOADING,
  CHECK_CART_SUCCESS,
  CHECK_CART_FAIL,
  CONFIRM_CART_LOADING,
  CONFIRM_CART_SUCCESS,
  CONFIRM_CART_FAIL,
  SET_ECOMMERCE_CONFIG,
  SET_PAYMENT_METHODS,
} from "../type";
import { serverResponse } from "../../util/fakeServer";

const initState = {
  step: 1,
  deliveryMethod: null,

  shippingData: {
    nome: "",
    cognome: "",
    email: "",
    telefono: "",
    indirizzo: "",
    citta: "",
    cap: "",
    note: "",
  },

  markets: [],
  selectedStore: null,
  pickupDate: null,
  availableSlots: [],
  selectedSlot: null,

  shippingCost: null,
  shippingCostLoading: false,
  shippingCostError: null,
  shippingAvailable: null,

  paymentMethod: null,

  // Metodi di pagamento (dinamici da backend). Default di fallback: contanti +
  // carta via Stripe -> il checkout funziona anche prima che l'endpoint esista.
  paymentMethods: [
    { code: 2, key: "cash", label: "Contanti" },
    { code: 3, key: "card", label: "Carta di credito/debito", provider: "stripe" },
  ],

  // Config e-commerce da azienda/get-info. Fallback = entrambi i metodi
  // abilitati, cosi' la UI non si blocca finche' la config non e' caricata.
  ecommerceConfig: {
    loaded: false,
    ecommerceType: 3,
    pickupEnabled: true,
    deliveryEnabled: true,
    // salvate per sviluppi futuri
    storeIdDefault: null,
    storeIdMaster: null,
    guestCheckout: false,
    maxDistanceKm: null,
    orderMinimumPickup: 0,
    orderMinimumDelivery: 0,
    deliveryCosts: 0,
    deliveryCostsLimit: 0,
  },

  checkResult: null,
  checkLoading: false,
  confirmLoading: false,
  orderError: null,

  validationErrors: {},
};

function checkoutReducer(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_CHECKOUT_STEP:
      return { ...state, step: payload, validationErrors: {} };

    case SET_DELIVERY_METHOD:
      return {
        ...state,
        deliveryMethod: payload,
        selectedStore: payload === "delivery" ? null : state.selectedStore,
        pickupDate: payload === "delivery" ? null : state.pickupDate,
        selectedSlot: payload === "delivery" ? null : state.selectedSlot,
        availableSlots: payload === "delivery" ? [] : state.availableSlots,
        shippingCost: payload === "pickup" ? 0 : null,
        shippingCostError: null,
        shippingAvailable: payload === "pickup" ? true : null,
      };

    case SET_SHIPPING_DATA:
      return {
        ...state,
        shippingData: { ...state.shippingData, ...payload },
        validationErrors: {},
      };

    case SET_SELECTED_STORE:
      return {
        ...state,
        selectedStore: payload,
        pickupDate: null,
        selectedSlot: null,
        availableSlots: [],
      };

    case SET_PICKUP_DATE:
      return {
        ...state,
        pickupDate: payload,
        selectedSlot: null,
        availableSlots: [],
      };

    case SET_SELECTED_SLOT:
      return { ...state, selectedSlot: payload };

    case SET_PAYMENT_METHOD:
      return { ...state, paymentMethod: payload };

    case FETCH_MARKETS_SUCCESS:
      return { ...state, markets: payload };

    case FETCH_SLOTS_SUCCESS:
      return { ...state, availableSlots: payload };

    case SHIPPING_COST_LOADING:
      return { ...state, shippingCostLoading: true, shippingCostError: null };

    case SET_SHIPPING_COST:
      return {
        ...state,
        shippingCost: payload.cost,
        shippingAvailable: payload.available,
        shippingCostLoading: false,
        shippingCostError: null,
      };

    case SHIPPING_COST_ERROR:
      return {
        ...state,
        shippingCostLoading: false,
        shippingCostError: payload,
        shippingAvailable: false,
      };

    case CHECK_CART_LOADING:
      return { ...state, checkLoading: true, checkResult: null, orderError: null };

    case CHECK_CART_SUCCESS:
      return { ...state, checkLoading: false, checkResult: payload };

    case CHECK_CART_FAIL:
      return { ...state, checkLoading: false, orderError: payload };

    case CONFIRM_CART_LOADING:
      return { ...state, confirmLoading: true, orderError: null };

    case CONFIRM_CART_SUCCESS:
      return { ...state, confirmLoading: false };

    case CONFIRM_CART_FAIL:
      return { ...state, confirmLoading: false, orderError: payload };

    case SET_ECOMMERCE_CONFIG: {
      // Riconciliazione unica allow_login vs guestCheckout: allow_login
      // (publication.json) VINCE. Se il login è disattivato non si può
      // pretendere un checkout con login obbligatorio -> l'ospite è sempre
      // consentito. guestCheckout "effettivo" = guestCheckout || !allow_login.
      const merged = { ...state.ecommerceConfig, ...payload, loaded: true };
      if (!serverResponse.config.allow_login) merged.guestCheckout = true;
      return { ...state, ecommerceConfig: merged };
    }

    case SET_PAYMENT_METHODS:
      return { ...state, paymentMethods: payload };

    case RESET_CHECKOUT:
      // Preserva config e metodi di pagamento del tenant (non sono dato d'ordine).
      return {
        ...initState,
        ecommerceConfig: state.ecommerceConfig,
        paymentMethods: state.paymentMethods,
      };

    default:
      return state;
  }
}

export default checkoutReducer;
